import { useSendAnalyticsEvent } from './analytics';
import { useDataContext } from 'src/contexts';
import * as Sentry from '@sentry/react';
import { toast } from 'react-toastify';

const postHogEventName = 'pvo_media_share';

export const useShareMedia = () => {
  const { sendEvent } = useSendAnalyticsEvent();
  const setIsLoading = useDataContext((ctx) => ctx.setIsLoading);
  const pvoData = useDataContext((ctx) => ctx.pvoData);

  const handleSendEvent = () => {
    sendEvent(postHogEventName);
  };

  const share = async () => {
    setIsLoading(true);

    try {
      const file = pvoData.files?.[0];

      if (!file?.blobFile) {
        return;
      }

      if (navigator.share) {
        try {
          await navigator.share({
            title: 'PlayWall Media',
            text: '',
            files: [file.blobFile],
          });
          handleSendEvent();
          return;
        } catch (filesError) {
          if (
            filesError instanceof Error &&
            (filesError.message.includes('files') ||
              filesError.message.includes('not supported') ||
              filesError.message.includes('Passing files'))
          ) {
            if (file?.url) {
              try {
                await navigator.share({
                  title: 'PlayWall Media',
                  text: 'Check out this media from PlayWall',
                  url: file.url,
                });
                handleSendEvent();
                return;
              } catch (urlError) {
                if (
                  urlError instanceof Error &&
                  (urlError.name === 'AbortError' ||
                    urlError.name === 'NotAllowedError')
                ) {
                  return;
                }
              }
            }
          } else {
            throw filesError;
          }
        }
      }

      if (file?.url) {
        window.open(file.url, '_blank');
        handleSendEvent();
      } else {
        throw new Error('File URL is not available');
      }
    } catch (error) {
      if (error instanceof Error && error.name === 'AbortError') {
        return;
      }

      if (
        error instanceof Error &&
        (error.name === 'NotAllowedError' ||
          error.message.includes('not allowed by the user agent'))
      ) {
        return;
      }

      Sentry.captureException(error, {
        extra: {
          eventName: postHogEventName,
          userAgent: navigator.userAgent,
        },
      });
      toast.error('An error occurred while sharing files.');
    } finally {
      setIsLoading(false);
    }
  };

  return { share };
};
